import React from "react";
import Image from "next/image";

const Footer = () => {
  return (
    <div className="bg-white md:p-16 py-12 px-5">
      <div className="flex flex-col md:flex-row justify-between items-center gap-5 max-w-7xl w-full mx-auto">
        <Image
          src="/rebolt-branding/rebolt-full-dark.png"
          alt="Rebolt Logo"
          width={100}
          height={100}
          className="h-10 w-auto"
        />
        <div className="h-px w-full bg-ash-300 block md:hidden" />
        <p className="text-black text-sm">© 2025 Rebolt. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
